// ============================================================================
// MINTIKK — ALL SITE COPY IN ONE PLACE (edit here)
// Brand voice: short, calm, declarative. Sentence case. No exclamation marks.
// ============================================================================

export const BRAND = {
  wordmark: "mintikk",
  caption: "DISSOLVABLE CAFFEINE STRIPS",
  shop: "SHOP",
};

// Section ids drive the right-side mint progress dots (in scroll order).
export const SECTIONS = [
  { id: "hero", label: "Hero" },
  { id: "statement", label: "Statement" },
  { id: "denim", label: "Carry it anywhere" },
  { id: "tongue", label: "Dissolves in seconds" },
  { id: "people", label: "For modern moments" },
  { id: "specs", label: "Specs" },
  { id: "cta", label: "Shop" },
  { id: "footer", label: "Footer" },
];

export const HERO = {
  line1: "focus,",
  line2: "anywhere.",
};

export const STATEMENT = {
  // "reimagined" is rendered mint-ink italic in the component.
  pre: "Caffeine, ",
  accent: "reimagined",
  post: ". Clean, precise energy in a strip that dissolves in seconds.",
};

export const BANDS = {
  denim: {
    eyebrow: "Carry it anywhere",
    heading: "Pocket-sized focus.",
    body: "Slim enough to disappear into any pocket. Twenty strips, ready when you are — no can, no spill, no noise.",
    asset: "/assets/band-denim.webp?v=4",
    alt: "mintikk box half-emerging from the back pocket of indigo denim",
  },
  tongue: {
    eyebrow: "Dissolves in seconds",
    heading: "One strip. Instant lift.",
    body: "Rests on the tongue and dissolves in under thirty seconds. Fast absorption, a clean hit of peppermint, nothing to swallow.",
    asset: "/assets/band-tongue.webp?v=4",
    alt: "translucent mint strip dissolving on a tongue",
  },
  people: {
    eyebrow: "For modern moments",
    heading: "Sharp when it counts.",
    body: "Deep work at the desk, an early session at the gym, the long drive home. Calm, deliberate energy for the moments that matter.",
    asset: "/assets/band-people.webp?v=6",
    alt: "mintikk box lifted from a leather handbag",
  },
};

export const SPECS = {
  heading: "Designed for focus, made simple.",
  items: [
    { value: "75mg", label: "caffeine" },
    { value: "<30s", label: "dissolve" },
    { value: "0g", label: "sugar" },
  ],
};

export const CTA = {
  headline: "focus, anywhere.",
  sub: "20 strips · sugar free · vitamin B12",
  button: "SHOP MINTIKK",
};

export const FOOTER = {
  brand: "mintikk",
  line: "food supplement",
  url: "mintikk.com",
  links: ["Ingredients & allergens", "Privacy"],
};
